import { ISiteNameSansId } from '../../ts/ServerApi/types/ISiteNameSansId';
import { AppState } from '../state/AppState';


export function selectSites(state: AppState): ReadonlyArray<ISiteNameSansId> {
  return state.sites;
}
